import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Icon from '../../../../components/Icon';
export const DiffIcon = ({ positive }) => {
    return _jsx(Icon, { className: positive ? 'icon--rotate-270deg' : 'icon--rotate-90deg', name: "long-arrow-right" });
};
